export const url = process.env.NEXT_PUBLIC_SERVER_HOST;
export const cdnUrl = `https://content.imageresizer.com`;
